/* eslint-disable react/jsx-no-undef */
import { IonSpinner } from '@ionic/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ModeSwitch, { ModeOption } from '../../components/ModeSwitch'
import { useInvoices } from '../../hooks/useInvoices'
import PageWrapper from '../../wrappers/pageWrapper/PageWrapper'
import { InvoiceTypeInfo } from './components/InvoiceTypeInfo'
import { PaidInvoices } from './components/PaidInvoices'
import { UnpaidInvoices } from './components/UnpaidInvoices'

type InvoiceTab = 'paid' | 'unpaid'

const Invoices: React.FC = () => {
	const [activeTab, setActiveTab] = useState<InvoiceTab>('unpaid')

	const { t } = useTranslation('pages_invoices')
	const { isLoading } = useInvoices()

	const modeOptions: ModeOption<'unpaid' | 'paid'>[] = [
		{ label: t('unpaid'), mode: 'unpaid' },
		{ label: t('paid'), mode: 'paid' },
	]

	return (
		<PageWrapper page='invoices'>
			<ModeSwitch options={modeOptions} currentMode={activeTab} onModeChange={setActiveTab} />

			<div className='mt-4'>
				<InvoiceTypeInfo />
			</div>

			{isLoading ? (
				<div className='spinner'>
					<IonSpinner className='text-brand-primary-100-light dark:text-brand-primary-100-dark' />
				</div>
			) : (
				<div className='flex flex-col flex-grow h-full mt-4'>
					{activeTab === 'unpaid' ? <UnpaidInvoices /> : <PaidInvoices />}
				</div>
			)}
		</PageWrapper>
	)
}

export default Invoices
